<ng-container *ngIf="sessionService.getUser() !== null">
    <div class="row gy-4">
        <div class="col-12">
            <mat-card >
                <mat-card-header>
                    <h2>Select Outing to Manage</h2>
                </mat-card-header>
                <mat-card-content>
                    <outing-outingiteration-select></outing-outingiteration-select>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-6">
            <mat-card  class="mat-elevation-z6">
                <mat-card-header>
                    <h2>Current Outing Information</h2>
                </mat-card-header>
                <mat-card-content>
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                    <div class="container-fluid">
                        <ng-container *ngIf="iterationHistoryCounts.length === 0">
                            <div class="row">
                                <div class="no-data">No Data</div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="iterationHistoryCounts.length > 0">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <h4 class="mat-h4">Name</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">Start Date</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">Registration Code</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">Course</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">Cost</h4>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row">
                                        <h4 class="mat-h4">{{selectedOuting?.name}}</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">{{selectedIteration?.startDate | date: 'mediumDate'}}</h4>
                                    </div>
                                    <div class="row">
                                        <ng-container>
                                            <h4 class="mat-h4" *ngIf="selectedIteration?.registrationCode">
                                                {{selectedIteration?.registrationCode}}</h4>
                                            <h4 class="mat-h4" *ngIf="!selectedIteration?.registrationCode">N/A</h4>
                                        </ng-container>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">{{selectedIteration?.courseName}}</h4>
                                    </div>
                                    <div class="row">
                                        <h4 class="mat-h4">${{selectedIteration?.cost}}</h4>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-6" *ngIf="iterationHistoryCounts">
            <mat-card  class="mat-elevation-z6">
                <mat-card-header>
                    <h2>Iteration History</h2>
                </mat-card-header>
                <mat-card-content>
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                    <ng-container *ngIf="iterationHistoryCounts.length === 0">
                        <div class="row">
                            <div class="no-data">No Data</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="iterationHistoryCounts.length > 0">
                        <table mat-table [dataSource]="iterationHistoryCounts">
                            <ng-container matColumnDef="totalHasPaid">
                                <th mat-header-cell *matHeaderCellDef> Total Golfers Paid </th>
                                <td mat-cell *matCellDef="let iterationHistory"> {{iterationHistory.totalHasPaid}} </td>
                            </ng-container>
                            <ng-container matColumnDef="totalCheckedIn">
                                <th mat-header-cell *matHeaderCellDef> Total Golfers Checked In </th>
                                <td mat-cell *matCellDef="let iterationHistory"> {{iterationHistory.totalCheckedIn}} </td>
                            </ng-container>
                            <ng-container matColumnDef="total">
                                <th mat-header-cell *matHeaderCellDef> Total Players </th>
                                <td mat-cell *matCellDef="let iterationHistory"> {{iterationHistory.total}} </td>
                            </ng-container>
                            <ng-container matColumnDef="startDate">
                                <th mat-header-cell *matHeaderCellDef> Start Date </th>
                                <td mat-cell *matCellDef="let iterationHistory"> {{iterationHistory.startDate | date:
                                    'mediumDate'}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="sessionService.getUser() === null">
    <dashboard-organizer-skeleton></dashboard-organizer-skeleton>
</ng-container>